import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
// import toQueryString from "to-querystring";

const API_URL = config.API_URL;

const view = (values) => {
  const result = values && values.result ? values.result : "";
  const action = `custompages`;
  const data = {
    action: action,
    pagination: false, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const customPagesApiController = {
  view,
};
export default customPagesApiController;
